import type { CSSProperties, ReactNode } from 'react';
import styles from './SplitPanel.module.css';

interface SplitPanelProps {
  image: string;
  imageAlt: string;
  /** Lado en el que se coloca la imagen. */
  imagePosition?: 'left' | 'right';
  /** Alto mínimo de la imagen en escritorio (px), tal y como fija el diseño. */
  imageMinHeight?: number;
  /**
   * `cover` recorta para llenar la caja; `contain` muestra la imagen entera.
   * Las infografías con texto necesitan `contain`: al recortarlas se pierden
   * datos (en la de Asistencia 24h se comía el teléfono y tres líneas).
   */
  imageFit?: 'cover' | 'contain';
  /** Sin borde, radio ni sombra: para anidarlo dentro de otra tarjeta. */
  bare?: boolean;
  contentClassName?: string;
  children: ReactNode;
}

export default function SplitPanel({
  image,
  imageAlt,
  imagePosition = 'right',
  imageMinHeight = 320,
  imageFit = 'cover',
  bare = false,
  contentClassName,
  children,
}: SplitPanelProps) {
  const panelClassName = bare ? `${styles.panel} ${styles.bare}` : styles.panel;
  const imageStyle: CSSProperties = { minHeight: `${imageMinHeight}px` };
  const imageClassName = imageFit === 'contain' ? `${styles.image} ${styles.contain}` : styles.image;
  const picture = <img className={imageClassName} style={imageStyle} src={image} alt={imageAlt} />;

  return (
    <div className={panelClassName}>
      {imagePosition === 'left' ? picture : null}
      <div className={contentClassName ? `${styles.content} ${contentClassName}` : styles.content}>{children}</div>
      {imagePosition === 'right' ? picture : null}
    </div>
  );
}
